import ValidationResult from '../common/ValidationResult';

export default class LoadFailureResult extends ValidationResult {
    isValid = false
    errorMessage =  <>
                        <span>Data failed to load.</span><br/>
                        <span>Please refresh the page.</span>
                    </>              
}